import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import compact from 'lodash/compact';
import PointsValue from '../atoms/PointsValue';
import { sumPersonaScores, sumScores } from '../../data/Score';
import type { PersonaScores, Score } from '../../data/Score';

const Table = styled.table`
	background-color: ${(props) => props.theme.colors.darkBlue};
	border-collapse: collapse;
	font: ${(props) => props.theme.font.default};
	width: 100%;
`;

const Row = styled.tr`
	:nth-child(odd) {
		background-color: ${(props) => props.theme.colors.veryDarkBlue};
	}
`;

const Name = styled.td`
	font-size: 1.5vmin;
	letter-spacing: 1px;
	padding: 1% 3%;
`;

const Value = styled.td`
	font-size: 1.8vmin;
	letter-spacing: 1px;
	padding: 1% 3%;
	text-align: right;
`;

interface Props {
	conceptScore?: Score;
	personaScores?: PersonaScores;
}

const ScoreTable: FunctionComponent<Props> = (props: Props) => {
	const { conceptScore, personaScores } = props;
	const score = sumScores(
		compact([conceptScore, sumPersonaScores(personaScores ?? {})])
	);

	return (
		<Table>
			<tbody>
				<Row key="qualityOfLife">
					<Name>
						<Trans>quality_of_life</Trans>
					</Name>
					<Value>
						<PointsValue points={score.qualityOfLife} />
					</Value>
				</Row>
				<Row key="environment">
					<Name>
						<Trans>environment</Trans>
					</Name>
					<Value>
						<PointsValue points={score.environment} />
					</Value>
				</Row>
				<Row key="happiness">
					<Name>
						<Trans>happiness</Trans>
					</Name>
					<Value>
						<PointsValue points={score.happiness} />
					</Value>
				</Row>
			</tbody>
		</Table>
	);
};

export default ScoreTable;
